import { defineComponent as _defineComponent } from 'vue'
import Chat from '../Chat/index';
import MasterApply from '../RoomFooter/ApplyControl/MasterApplyControl/index';
import ManageMember from '../ManageMember/index';
import popup from '../common/base/PopUpH5.vue';
import useSideBar from './useSideBarHooks';
import ChatEditor from '../Chat/ChatEditor';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  setup(__props) {

const { title, sidebarName, showSideBar } = useSideBar();

return { __sfc: true,title, sidebarName, showSideBar, Chat, MasterApply, ManageMember, popup, ChatEditor }
}

})